<template>
  <div class="gx-tk">
    <div class="gx-tk__tip">任务通过「商品看板 → 发布任务」下发，也可在「任务模板」配置模板</div>
    <div class="gx-tk__stats">
      <div class="gx-tk__stats-head">
        <div class="gx-tk__stats-title">可视化报表</div>
        <div class="gx-tk__stats-dec">任务完成率 · 类型分布 · 平台对比</div>
      </div>
      <div class="gx-tk__stats-body">
        <div class="gx-tk__stats-cards">
          <div v-for="s in statCards" :key="s.label" class="gx-tk__stats-card" :style="{background:s.bg, borderColor: s.color + '25' }">
            <div class="gx-tk__stats-label">{{ s.label }}</div>
            <div class="gx-tk__stats-value" :style="{ color: s.color }">{{ s.value }}</div>
          </div>
        </div>
        <div class="gx-tk__stats-dists">
          <div class="gx-tk__stats-dist-col">
            <div class="gx-tk__stats-dist-title">任务类型分布</div>
            <div class="gx-tk__stats-dist-tags">
              <div v-for="(s,i) in taskTypeDist" :key="i" class="gx-tk__stats-dist-tag" :style="{background:s.color + '14', borderColor: s.color + '45' }">
                <span class="gx-tk__stats-dist-dot" :style="{background:s.color}"></span>
                <span class="gx-tk__stats-dist-label" :style="{color:s.color}">{{ s.label }}</span>
              </div>
            </div>
          </div>
          <div class="gx-tk__stats-dist-col">
            <div class="gx-tk__stats-dist-title">平台分布</div>
            <div v-for="(row,index) in platformDist" :key="index" class="gx-tk__stats-dist-item" >
              <div class="gx-tk__stats-dist-row" :style="{color:row.color}">
                <span class="gx-tk__stats-dist-label" :class="'gx-tk__stats-dist-label--'+row.shopType">{{ row.label }}</span>
                <span class="gx-tk__stats-dist-val">{{ row.value }}件 ({{ row.percent }}%)</span>
              </div>
              <div class="gx-tk__stats-dist-track">
                <span class="gx-tk__stats-dist-fill" :style="{ width: row.percent + '%', background: row.color }"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--筛选栏-->
    <div class="gx-tk__filter custom-form-wrap">
      <el-form inline size="mini" class="gx-tk__spacer">
        <el-form-item>
          <el-select v-model="searchData.platform" placeholder="全部" clearable class="w120" @change="switchPlatform">
            <el-option v-for="(item,index) in platformDist" :key="index" :value="item.shopType" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-select v-model="searchData.group_id" placeholder="店铺分组" clearable filterable class="w120" @change="loadData(1)">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchData.shop_id" placeholder="全部店铺" clearable filterable class="w120" @change="loadData(1)">
            <el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchData.product_id" placeholder="商品ID" clearable @blur="loadData(1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchData.type" placeholder="全部" clearable class="w120" >
            <el-option v-for="(item,index) in taskTypeDist" :key="index" :value="item.key" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchData.status" placeholder="全部状态" clearable class="w120" @change="loadData(1)">
            <template v-for="item in statusMap">
              <el-option :key="item.value" :value="item.value" :label="item.label" v-if="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <div class="gx-tk__spacer"></div>
        <el-form-item>
          <button type="button" class="btn btn--primary" @click="loadData(1)">查询</button>
          <button type="button" class="btn" @click="resetSearch">重置</button>
        </el-form-item>
      </el-form>
    </div>
    <div class="gx-tk__tabs">
      <div class="gx-tk__tab" :class="{'gx-tk__tab--on':searchData.status===item.value,'text-orange':item.value==='missing'&&item.count>0}"
           v-for="item in statusMap" :key="item.value" @click="changeTab(item.value)">
        {{item.label}}<span class="gx-tk__tab-num" v-if="item.count>0">({{item.count}})</span>
        <span class="gx-tk__tab-dot" v-if="item.value==='missing'&&item.count>0"></span>
      </div>
    </div>
    <div class="gx-tk__table-pager">
      <div class="gx-tk__table">
        <table>
          <thead>
          <tr>
            <th v-for="h in ['任务名称', '状态', '积分奖励', '操作']" :key="h">{{ h }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(t, i) in taskList" :key="t.task_id || i">
            <td class="gx-tk__task-name">{{ t.task_name || '--' }}</td>
            <td>
              <span class="gx-tk__status" :style="statusStyle(t.status)">{{ statusText(t.status) }}</span>
            </td>
            <td class="gx-tk__mono gx-tk__gold">{{ t.reward_points != null ? t.reward_points : '--' }}</td>
            <td>
              <button v-if="t.status === 'in_progress'" class="gx-tk__op gx-tk__op--primary" @click="completeTask(t)">完成任务</button>
              <span v-else class="gx-tk__dim">--</span>
            </td>
          </tr>
          <tr v-if="!taskList.length">
            <td :colspan="4" class="gx-tk__empty">暂无任务数据</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="gx-tk__pager">
        <Pagination :total="total" :page.sync="page" :limit.sync="limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="loadData(page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>
    <under-development ref="underDevelopmentRef"></under-development>
  </div>
</template>
<script>
import {completeTask, getMyTasks, getTaskStats} from "@/api/main/task";
import Pagination from '../../components/newUi/Pagination.vue'
import {mapActions} from "vuex";
import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";

export default {
  components: {UnderDevelopment, Pagination },
  data(){
    return {
      searchData: { status: '' },
      taskList: [],
      stats: { total: 0, pending: 0, in_progress: 0, completed: 0 },
      page: 1,
      limit: 20,
      total: 0,
      shopOptions:[],
      groupList:[],
    }
  },
  computed:{
    statCards() {
      return [
        { label: '全部任务', value: this.stats.total || 0, color: '#1a1a2e',bg:'#f5f5f8' },
        { label: '已完成', value: this.stats.completed || 0, color: '#52c41a',bg:'#f6ffed' },
        { label: '进行中', value: this.stats.in_progress || 0, color: '#1677ff',bg:'#e6f4ff' },
        { label: '待开始', value: this.stats.pending || 0, color: '#c8443c',bg:'#fff5f5' }
      ]
    },
    //可视报表虚拟数据
    taskTypeDist(){
      return [
        { label: '评价', value: this.stats.evaluation || 0, color: '#52c41a',key:'evaluation' },
        { label: '动销', value: this.stats.sellThrough || 0, color: '#1677ff',key:'sellThrough' },
        { label: '坑产', value: this.stats.pitProduction || 0, color: '#fa8c16',key:'pitProduction' },
        { label: '推广', value: this.stats.Promotion || 0, color: '#c8443c',key:'Promotion' },
      ]
    },
    platformDist(){
      return [
        { label: '抖店', value: 4,percent:80,shopType:1, color: '#c8443c' },
        { label: '微信小店', value: 1,percent:22,shopType:7, color: '#52c41a' },
      ]
    },
    statusMap(){
      return [
        {label:'全部任务',value:'',count:0},
        {label:'待开始',value:'pending',count:0},
        {label:'当天未完成',value:'unfinished',count:0},
        {label:'进行中',value:'in_progress',count:0},
        {label:'缺失任务',value:'missing',count:0},
        {label:'已完成',value:'completed',count:0},
        {label:'已过期',value:'expired',count:0},
      ]
    }
  },
  created() {
    this.$nextTick(()=>{
      this.$refs.underDevelopmentRef.show()
    })
    this.loadStats()
    this.loadShopList()
    this.loadGroupList()
    this.loadData(1)
  },
  methods:{
    ...mapActions({
      getShopList: 'shop_board/getShopList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
    }),
    loadShopList() {
      this.getShopList({
        data: { page_size: 100, page: 1, shop_type: this.searchData.platform },
        success: (res) => {
          if (res.code === 200 && res.data) {
            if (res.data.list && res.data.list.list) this.shopOptions = res.data.list.list
            else if (Array.isArray(res.data.list)) this.shopOptions = res.data.list
            else if (Array.isArray(res.data)) this.shopOptions = res.data
            else this.shopOptions = []
          }
        }
      })
    },
    loadGroupList() {
      this.getShopBoardGroupList({
        data: { with_count: 0 },
        success: (res) => {
          this.groupLoading = false
          if (res.code === 200) {
            this.groupList = res.data || []
            if (this.searchData.group_id && !this.groupList.find(item => item.id === this.searchData.group_id)) {
              this.searchData.group_id = ''
            }
          } else {
            this.$message.error(res.message || '获取分组失败')
          }
        }
      })
    },
    switchPlatform() {
      this.searchData.shop_id = ''
      this.loadShopList()
      this.loadData(1)
    },
    changeTab(val){
      this.searchData.status = val
      this.loadData(1)
    },
    loadData(page) {
      this.page = page
      const params = { page: this.page, limit: this.limit }
      if (this.searchData.status) params.status = this.searchData.status
      getMyTasks(params).then((res) => {
        if (res.code === 200) {
          this.taskList = res.data.list || []
          this.total = res.data.total || 0
        }
      }).catch(() => {
        this.$message.error('加载任务失败')
      })
    },
    loadStats() {
      const params = {}
      getTaskStats(params).then((res) => {
        if (res.code === 200) this.stats = res.data || {}
      }).catch(() => {})
    },
    resetSearch() {
      this.searchData = { status: null }
      this.loadData(1)
    },
    statusStyle(status) {
      const map = {
        pending: ['#3FB6E0', 'rgba(63,182,224,.1)', 'rgba(63,182,224,.3)'],
        in_progress: ['#FB923C', 'rgba(251,146,60,.1)', 'rgba(251,146,60,.3)'],
        completed: ['#4ADE80', 'rgba(74,222,128,.1)', 'rgba(74,222,128,.3)']
      }
      const [color, bg, border] = map[status] || ['#4A4A6A', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.3)']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    statusText(status) {
      const map = { pending: '待开始', in_progress: '进行中', completed: '已完成' }
      return map[status] || status || '--'
    },
    completeTask(task) {
      this.$confirm(`确认完成任务「${task.task_name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        completeTask({ task_id: task.task_id }).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message || '任务已完成')
            this.loadData(this.page)
            this.loadStats()
          } else {
            this.$message.error(res.msg || res.message || '完成任务失败')
          }
        }).catch(() => {
          this.$message.error('完成任务失败')
        })
      }).catch(() => {})
    }
  }
}

</script>

<style scoped>
.w120{
  width: 120px;
}
.gx-tk__tip{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(102, 102, 102);
  margin-bottom: 12px;
}
.gx-tk__stats {
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  background: rgb(255, 255, 255);
  overflow: hidden;
}
.gx-tk__stats-head{
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 14px;
  background: rgb(238, 241, 246);
}
.gx-tk__stats-title{
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: rgb(26, 26, 46);
  position: relative;
  padding-left: 10px;
}
.gx-tk__stats-title::before{
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 3px;
  height: 13px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
}
.gx-tk__stats-dec{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  flex: 1 1 0%;
}
.gx-tk__stats-body{
  padding: 12px 16px;
}
.gx-tk__stats-cards{
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.gx-tk__stats-card {
  padding: 10px 13px;
  border-radius: 7px;
  background: rgb(245, 245, 248);
  border: 1px solid rgba(26, 26, 46, 0.145);
}
.gx-tk__stats-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-bottom: 5px;
}
.gx-tk__stats-value {
  font-family: "JetBrains Mono", monospace;
  font-size: 22px;
  font-weight: 700;
}

.gx-tk__stats-dists {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.gx-tk__stats-dist-col {
  padding: 10px 13px;
  border-radius: 7px;
  background: rgb(248, 249, 252);
  border: 1px solid rgb(224, 224, 236);
}
.gx-tk__stats-dist-title {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(102, 102, 102);
  font-weight: 600;
  margin-bottom: 8px;
}
.gx-tk__stats-dist-tags{
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-tk__stats-dist-tag{
  width: max-content;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 10px;
  border: 1px solid rgba(232, 93, 93, 0.27);
}
.gx-tk__stats-dist-dot{
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.gx-tk__stats-dist-item{
  margin-bottom: 6px;
}
.gx-tk__stats-dist-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}
.gx-tk__stats-dist-label {
  padding: 1px 7px;
  border-radius: 4px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
}
.gx-tk__stats-dist-label--1{
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: var(--gx-red);
}
.gx-tk__stats-dist-label--7{
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
  color: var(--gx-green);
}
.gx-tk__stats-dist-track {
  width: 100%;
  height: 5px;
  border-radius: 3px;
  background: rgb(224, 224, 232);
  overflow: hidden;
}
.gx-tk__stats-dist-fill {
  display: block;
  height: 100%;
  border-radius: 3px;
  transition: width .3s;
}
.gx-tk__stats-dist-val {
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  font-weight: 700;
}

.gx-tk__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  padding: 11px 14px;
  margin-bottom: 12px;
  box-shadow: rgba(0, 0, 0, 0.04) 0 1px 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.gx-tk__spacer {
  flex: 1;
}

.gx-tk__tabs{
  display: flex;
  border: 1px solid rgb(224, 224, 236);
  margin-bottom: 10px;
  background: rgb(255, 255, 255);
  border-radius: 8px 8px 0px 0px;
}
.gx-tk__tab{
  padding: 9px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  background: rgba(0, 0, 0, 0);
  color: rgb(102, 102, 102);
  white-space: nowrap;
  transition: 0.15s;
  position: relative;
}
.gx-tk__tab--on{
  border-bottom: 2px solid var(--gx-red);
  font-weight: 600;
  color: var(--gx-red) !important;
}
.gx-tk__tab-num{
  margin-left: 4px;
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  color: rgb(153, 153, 153);
}
.gx-tk__tab-dot{
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--gx-orange);
}
.gx-tk__table-pager{
  background: rgb(255, 255, 255);
  border-radius: 0px 0px 8px 8px;
  border:1px solid rgb(224, 224, 236);
  border-top:none;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
}
.gx-tk__pager{
  padding: 9px 14px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
}

.gx-tk__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-tk__table th {
  padding: 10px 14px;
  text-align: left;
  background: #EEF1F6;
  font-size: 11px;
  font-weight: 500;
  color: #606266;
  border-bottom: 1px solid #E1E5EE;
  letter-spacing: .04em;
}
.gx-tk__table td {
  padding: 12px 14px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid rgba(212, 169, 70, .07);
}

.gx-tk__task-name {
  font-weight: 500;
}
.gx-tk__status {
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 500;
  display: inline-block;
}
.gx-tk__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
}
.gx-tk__gold {
  color: #D4A946;
  font-weight: 600;
}
.gx-tk__dim {
  color: #6A6A8A;
}
.gx-tk__op {
  height: 26px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-tk__op--primary {
  background: rgba(212, 169, 70, .1);
  border-color: rgba(212, 169, 70, .3);
  color: #E8C778;
}
.gx-tk__op--primary:hover {
  background: #D4A946;
  color: #fff;
}
.gx-tk__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}

@media (max-width: 900px) {
  .gx-tk__stats-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
